import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { Link } from 'react-router-dom';
import Image from '~/components/Image';
import { useFullRoutes } from '~/hooks';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import getUserTypeTitle from '~myAccount/pages/AccountDetails/utils/getUserTypeTitle';

const UserTitle = () => {
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const { data: userProfile } = useGetUserProfileQuery();
  const { data: response } = useGetUserQuery();

  const userTypeTitle = getUserTypeTitle(response?.user as any);
  const userPic = response?.user.personal_photo?.thumbnails.large as string;

  return (
    <div className="border-b border-gray pb-2x px-3x flex gap-3 items-center">
      <Image imgSrc={userPic || ''} />
      <div className="flex items-center flex-1">
        <div className="flex flex-col gap-x flex-1">
          <p className="text-title_4">{userProfile?.name}</p>
          <p className="text-body_1 text-gray__dark_1">{userTypeTitle}</p>
        </div>
        <Link to={MY_ACCOUNT_URL.UPDATE_NAME}>
          <Icon name="edit" className="text-blue" />
        </Link>
      </div>
    </div>
  );
};

export default UserTitle;
